import AdminLanguage from "../language/AdminLanguage";
import {toast} from "react-toastify";
import Language from "../language/Language";

export const callToaster = (toastText) =>{
    let language = JSON.parse(localStorage.getItem("userInfos")) ? JSON.parse(localStorage.getItem("userType")) === 'admin' ? AdminLanguage[JSON.parse(localStorage.getItem("userInfos")).language] : Language[JSON.parse(localStorage.getItem("userInfos")).language] : {}
    toast.success(`${language[toastText]}`)
}